module.exports = __webpack_public_path__ + "img/ru.6cb6ebe8.svg";